import { ClipboardEventHandler } from 'react';
import { FieldError, FieldErrorsImpl, FieldValues, Merge, Path, UseFormRegister } from 'react-hook-form';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';
import { PhoneNumber } from 'libphonenumber-js/types';
import { TTooltipPlacement } from '../Tooltip/Tooltip.types';

export const EInputType = {
	text: 'text',
	url: 'url',
	email: 'email',
	password: 'password',
	price: 'price',
	integer: 'integer',
	float: 'float',
} as const;

export type InputType = TValueOfStringRecord<typeof EInputType>

export type TInputValue = string | number | PhoneNumber | undefined;

export interface IInputProps<T extends FieldValues> {
	className?: string;
	containerClassName?: string;
	disabled?: boolean;
	errorMessage?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
	isError?: boolean;
	isPhoneNumber?: boolean;
	isReadOnly?: boolean;
	infoTooltip?: string | JSX.Element;
	label?: string;
	labelAction?: () => void;
	labelActionDisabled?: boolean;
	labelActionText?: string;
	labelActionTooltip?: string;
	maxLength?: number;
	isMaxLengthCounter?: boolean;
	name: Path<T>;
	onBlur?: (name?: string, value?: TInputValue) => void;
	onChange?: (_value: string) => void;
	onEnterKeyDown?: (_value: string) => void;
	onFocus?: (name?: string, value?: TInputValue) => void;
	placeholder?: string;
	regexValidation?: RegExp;
	register?: UseFormRegister<T>;
	required?: boolean;
	setValue?: (_name: any, _value: any) => void;
	tooltipContent?: JSX.Element | string;
	tooltipPlacement?: TTooltipPlacement;
	type?: InputType;
	value?: string | number | PhoneNumber;
	valueLength?: number;
	withCustomValidation?: boolean;
	withUseForms?: boolean;
	onPaste?: ClipboardEventHandler<HTMLInputElement>;
}
